import { useSeoApi } from '@/api/sdk-api';
import { adaptPackagesToCosts } from '@/constants/tariff';
import { setAbPackage, updateCurrentTariff } from '@/redux/slices/user-slice';
import { type AbPackage, type GetAbPackageResponse } from '@/types/types';
import { adaptAbPackage } from '@/utils/adapt-ab-package';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

export function useLoadAbPackage(): {
  loadAbPackage: () => Promise<AbPackage | null>;
} {
  const { getAbPackage } = useSeoApi();
  const dispatch = useDispatch();

  const loadAbPackage = useCallback(async (): Promise<AbPackage | null> => {
    try {
      const resp = (await getAbPackage()) as GetAbPackageResponse;
      const ab = adaptAbPackage(resp.data);

      dispatch(setAbPackage(ab));

      const withCosts = adaptPackagesToCosts(ab.packagesWithTariff);
      const withoutCosts = adaptPackagesToCosts(ab.packagesWithoutTariff);

      dispatch(
        updateCurrentTariff({
          abTestsCosts: withCosts,
          abTestsCostsWithoutTariff: withoutCosts,
        }),
      );

      return ab;
    } catch (e) {
      console.error(e);
      dispatch(setAbPackage(null));

      return null;
    }
  }, [dispatch, getAbPackage]);

  return { loadAbPackage };
}
